import React, { useRef, useState, useCallback } from 'react';
import { d as debounce } from './debounce-ClFpMKL7.js';
import classnames from 'classnames';
import { tokens } from '@jobber/design';
import { I as InputText } from './InputText-BcnP-GlH.js';
import { u as useDataListContext } from './DataListContext-CyU4jeBU.js';
import { S as SEARCH_DEBOUNCE_DELAY } from './DataList.const-CjTyAhOC.js';
import { B as Button } from './Button-DJQVVE0-.js';
import { A as AnimatedSwitcher } from './AnimatedSwitcher-CFgZoPkz.js';

var styles = {"wrapper":"tj0MOMhLEEY-","searchInput":"SaPMOnvw-3c-","searchInputVisible":"_3S1-91v2SYI-","searchButton":"_9GlBktsUALw-","withNoFilters":"_3Pjrt42x454-"};

const DATA_LIST_SEARCH_TEST_ID = "ATL-DataList-Search-input-wrapper";
// This component is meant to capture the props of the DataList.Search
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function DataListSearch(_) {
    return null;
}
/**
 * Renders the DataList.Search component.
 */
function InternalDataListSearch() {
    const inputRef = useRef(null);
    const [visible, setVisible] = useState(false);
    const { searchComponent, filterComponent, sorting, title } = useDataListContext();
    const debouncedSearch = useCallback(debounce((value) => { var _a; return (_a = searchComponent === null || searchComponent === void 0 ? void 0 : searchComponent.props) === null || _a === void 0 ? void 0 : _a.onSearch(value); }, SEARCH_DEBOUNCE_DELAY), [searchComponent === null || searchComponent === void 0 ? void 0 : searchComponent.props.onSearch]);
    if (!searchComponent)
        return null;
    const { placeholder, initialValue } = searchComponent.props;
    return (React.createElement("div", { className: classnames(styles.wrapper, {
            [styles.withNoFilters]: !filterComponent && !sorting,
        }) },
        React.createElement("div", { "data-testid": DATA_LIST_SEARCH_TEST_ID, className: classnames(styles.searchInput, {
                [styles.searchInputVisible]: visible,
            }) },
            React.createElement(InputText
            // If the initial value changes, reset the input.
            , { 
                // If the initial value changes, reset the input.
                key: initialValue, defaultValue: initialValue, ref: inputRef, placeholder: getPlaceholder(), onChange: debouncedSearch, prefix: { icon: "search" }, clearable: "always" })),
        React.createElement("div", { className: styles.searchButton },
            React.createElement(AnimatedSwitcher, { switched: visible, initialChild: React.createElement(Button, { variation: "subtle", icon: "search", ariaLabel: "Search", onClick: toggleSearch }), switchTo: React.createElement(Button, { variation: "subtle", icon: "remove", ariaLabel: "Close search bar", onClick: toggleSearch }) }))));
    function getPlaceholder() {
        if (placeholder)
            return placeholder;
        if (title)
            return `Search ${title}...`;
        return `Search...`;
    }
    function toggleSearch() {
        const visibility = !visible;
        setVisible(visibility);
        if (visibility && inputRef.current) {
            setTimeout(inputRef.current.focus, tokens["timing-quick"]);
        }
    }
}

export { DATA_LIST_SEARCH_TEST_ID as D, InternalDataListSearch as I, DataListSearch as a };
